import { render, staticRenderFns } from "./product-analysis-copy.vue?vue&type=template&id=d64e1444&"
import script from "./product-analysis-copy.vue?vue&type=script&lang=js&"
export * from "./product-analysis-copy.vue?vue&type=script&lang=js&"
import style0 from "./product-analysis-copy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports